import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { FloatingButtons } from './components/FloatingButtons';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Nosotros } from './pages/Nosotros';
import { Servicios } from './pages/Servicios';
import { AntesYDespues } from './pages/AntesYDespues';
import { Testimonios } from './pages/Testimonios';
import { Contacto } from './pages/Contacto';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-primary text-white font-sans selection:bg-gold selection:text-primary" data-id="element-2">
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/nosotros" element={<Nosotros data-id="element-9" />} data-id="element-8" />
            <Route path="/servicios" element={<Servicios data-id="element-11" />} data-id="element-10" />
            <Route path="/antes-y-despues" element={<AntesYDespues data-id="element-13" />} data-id="element-12" />
            <Route path="/testimonios" element={<Testimonios data-id="element-15" />} data-id="element-14" />
            <Route path="/contacto" element={<Contacto data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
        <FloatingButtons data-id="element-19" />
      </div>
    </Router>;
}